<div
  style="width: 100%"
  [class.disable]="!permissionsService.canAddProductsToCart()">
  <div
    class="counter-container counter-inactive"
    *ngIf="formControl.value <= 0 && !isFocused"
    (click)="increment()">
    <div class="inactive-plus-container">
      <mat-icon svgIcon="add-to-bag-icon" class="add-to-bag-icon"></mat-icon>
      <span *ngIf="buttonText" class="button-text">{{ buttonText }}</span>
    </div>
  </div>
  <div
    class="counter-container"
    [class.counter-active]="!listOfNeedsProduct"
    *ngIf="formControl.value > 0 || isFocused">
    <button (click)="decrement()" class="counter-button">
      <ng-container
        *ngIf="listOfNeedsProduct && formControl.value === 1; else minusIcon">
        <mat-icon svgIcon="trash-icon" class="trash-icon"></mat-icon>
      </ng-container>

      <ng-template #minusIcon>
        <mat-icon svgIcon="minus-icon" class="minus-icon"></mat-icon>
      </ng-template>
    </button>
    <input
      type="text"
      class="counter-input text-trim"
      #counterInput
      (focus)="onFocus()"
      (blur)="onBlur()"
      [formControl]="formControl"
      (input)="onQuantityChange($event)"
      [readonly]="!permissionsService.canAddProductsToCart()" />
    <button
      (click)="increment()"
      class="counter-button"
      [class.counter-button-disabled]="isAtMaxQuantity"
      [disabled]="isAtMaxQuantity">
      <mat-icon svgIcon="plus-icon" class="plus-icon"></mat-icon>
    </button>
  </div>
</div>
